import React from 'react';
import { BookOpen, Target, Users, Zap, Activity, Utensils, CloudRain, LifeBuoy, Calendar } from 'lucide-react';
export function ProductSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="w-full" data-id="element-191" data-mp="csa030wfr3fq">
      {/* SECTION 4 - SYSTEM PRESENTATION */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto text-center bg-white" data-id="element-192" data-mp="qjoknc5zrcow">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-blue-50 text-court-deep mb-6" data-id="element-193" data-mp="mid1nphmhppo">
          <Target className="w-7 h-7" data-id="element-194" data-mp="10ie59cp9vb8u" />
        </div>
        <h2 className="text-2xl sm:text-4xl md:text-5xl font-heading font-extrabold text-slate-900 mb-4 leading-tight" data-id="element-195" data-mp="10g1oh2v936xd">
          🏆 El Sistema N°1 para Profesores de Pádel
        </h2>
        <p className="text-base sm:text-xl text-slate-600 font-medium mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-196" data-mp="329r8zyfi7d3b">
          PADEL 360 — Colección Completa 12 Tomos + 6 Bonus — Todo resuelto,
          todos los niveles.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-5" data-id="element-197" data-mp="1b78196iwk1i">
          <StatBadge icon={<BookOpen className="w-5 h-5" data-id="element-199" data-mp="5csthix4i6nb" />} text="+280 páginas" data-id="element-198" data-mp="1bfofb1uu7hg" />
          <StatBadge icon={<Activity className="w-5 h-5" data-id="element-201" data-mp="a413ag2d7u10" />} text="+120 ejercicios graficados en cancha" data-id="element-200" data-mp="5ay51umn7weh" />
          <StatBadge icon={<Users className="w-5 h-5" data-id="element-203" data-mp="f22igpwo7977" />} text="Todos los niveles" data-id="element-202" data-mp="f3dqx312954n" />
          <StatBadge icon={<Zap className="w-5 h-5" data-id="element-205" data-mp="k3rwmef6w2zi" />} text='Sistema "Abre y Entra"' data-id="element-204" data-mp="k0dxdf1to9wa" />
        </div>
      </section>

      {/* SECTION 5 - LOS 12 TOMOS */}
      <section className="py-20 bg-slate-50 px-4 sm:px-6 lg:px-8 border-y border-slate-200" data-id="element-206" data-mp="t1bx3l589v92">
        <div className="max-w-7xl mx-auto" data-id="element-207" data-mp="2qt6hvgn77w3c">
          <div className="text-center mb-14" data-id="element-208" data-mp="2quhmtjsdr9w1">
            <h2 className="text-2xl sm:text-4xl md:text-5xl font-heading font-extrabold text-slate-900 mb-4" data-id="element-209" data-mp="2usym5h5k7g2w">
              Los <span className="text-court-deep" data-id="element-210" data-mp="201d25ut5e8i">12 Tomos</span> Completos
            </h2>
            <p className="text-base sm:text-xl text-slate-600 font-medium" data-id="element-211" data-mp="3t6kui3v5g2fs">
              Drills graficados · Por nivel y objetivo · Listos para usar mañana
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5" data-id="element-212" data-mp="6y34pf6aulvl">
            <TomoCard num="1" title="Nivel Inicial — Fase 1" desc="El primer contacto real con la pala. Grip, posición, contacto y confianza desde el primer minuto." level="Inicial" accent="text-sky-700 bg-sky-50 border-sky-200" data-id="element-213" data-mp="kxklb79fystv" />
            <TomoCard num="2" title="Nivel Inicial — Fase 2" desc="Del peloteo al juego real. Globo defensivo, volea básica y primer contacto con la pared." level="Inicial" accent="text-sky-700 bg-sky-50 border-sky-200" data-id="element-214" data-mp="ppvn6fnqsop2" />
            <TomoCard num="3" title="Intermedio 1 — Control y Posición" desc="Control direccional avanzado. Juego de fondo sistemático y movimiento de pareja sincronizado." level="Intermedio" accent="text-teal-700 bg-teal-50 border-teal-200" data-id="element-215" data-mp="1icc833aubkjh" />
            <TomoCard num="4" title="Intermedio 2 — Táctica de Pareja" desc="Sistema de red dominante. Coberturas, comunicación y cuándo bajar juntos de la red." level="Intermedio" accent="text-teal-700 bg-teal-50 border-teal-200" data-id="element-216" data-mp="1daefvjkgpfee" />
            <TomoCard num="5" title="Avanzado 1 — Variantes Técnicas" desc="Bandeja, víbora, globo con efecto y remate por tres. El salto al juego de alto nivel." level="Avanzado" accent="text-violet-700 bg-violet-50 border-violet-200" data-id="element-217" data-mp="pkk6jbzcq8yw" />
            <TomoCard num="6" title="Avanzado 2 — Sistema de Juego Completo" desc="Sistema ofensivo completo. Lectura del rival, juego bajo presión y partido táctico dirigido." level="Avanzado" accent="text-violet-700 bg-violet-50 border-violet-200" data-id="element-218" data-mp="dkc98stgeaaq" />
            <TomoCard num="7" title="Adultos Mayores — Fase 1" desc="Pádel adaptado para cuerpos maduros. Movilidad, equilibrio, seguridad y disfrute real de la cancha." level="Adultos" accent="text-amber-700 bg-amber-50 border-amber-200" data-id="element-219" data-mp="3vxa7mvalkv2s" />
            <TomoCard num="8" title="Adultos Mayores — Fase 2" desc="Juego de pareja adaptado, coordinación ojo-pala y torneo social seguro." level="Adultos" accent="text-amber-700 bg-amber-50 border-amber-200" data-id="element-220" data-mp="3h1kp574mf02t" />
            <TomoCard num="9" title="Kids — Fase 1" desc="El pádel como juego. Coordinación, exploración lúdica y primer amor por la cancha." level="Kids" accent="text-pink-700 bg-pink-50 border-pink-200" data-id="element-221" data-mp="1b8m2ojf6bpq8" />
            <TomoCard num="10" title="Kids — Fase 2" desc="Técnica lúdica y partido real con reglas adaptadas. El alumno que va a seguir jugando de grande." level="Kids" accent="text-pink-700 bg-pink-50 border-pink-200" data-id="element-222" data-mp="32wtuqcpa9k8j" />
            <TomoCard num="11" title="Lesiones — Prevención y Adaptación" desc="Protocolos para las 5 lesiones más comunes. Drills adaptados por zona y escalera de retorno al juego." level="Lesiones" accent="text-red-700 bg-red-50 border-red-200" data-id="element-223" data-mp="2f6ragirm1ikh" />
            <TomoCard num="12" title="Lesiones — Casos Especiales y Alta Definitiva" desc="Posoperatorio, prótesis y patologías crónicas. El sistema para cuidar al alumno más fiel que tienes." level="Lesiones" accent="text-red-700 bg-red-50 border-red-200" data-id="element-224" data-mp="3up2qfed9u8k2" />
          </div>

          <div className="mt-14 flex flex-wrap justify-center gap-3" data-id="element-225" data-mp="29gogc78ikl06">
            <BadgeItem icon="✏️" text="Ejercicios graficados en cada tomo" data-id="element-226" data-mp="24i4wqdhe7laz" />
            <BadgeItem icon="⚡" text='Sistema "Abre y Entra"' data-id="element-227" data-mp="24gtpg3oqnvf4" />
            <BadgeItem icon="📋" text="Fichas listas para imprimir" data-id="element-228" data-mp="1gtlmhses8yg9" />
            <BadgeItem icon="🌎" text="Contenido pensado para Latinoamérica" data-id="element-229" data-mp="1buqwa5ehk7m4" />
          </div>

          {/* EXTRA CTA BUTTON */}
          <div className="mt-14 text-center" data-id="element-230" data-mp="1qkgab17og63t">
            <button onClick={scrollToPricing} className="inline-flex items-center justify-center gap-2 bg-orange-500 hover:bg-orange-600 text-white text-base sm:text-lg font-heading font-extrabold py-4 px-8 rounded-xl shadow-xl shadow-orange-500/30 transition-all hover:scale-[1.03] uppercase tracking-wide" data-id="element-231" data-mp="1lsf1jp9pwxij">
              Ver precio y acceso <Zap className="w-5 h-5" data-id="element-232" data-mp="34oqhrluiu7ek" />
            </button>
          </div>
        </div>
      </section>

      {/* SECTION 6 - LOS 6 BONUS */}
      <section className="py-20 bg-white px-4 sm:px-6 lg:px-8 relative" data-id="element-233" data-mp="2vqy0ic58opoj">
        <div className="max-w-7xl mx-auto relative z-10" data-id="element-234" data-mp="2zrqbpaxo94ng">
          <div className="text-center mb-12" data-id="element-235" data-mp="2zs9rom3rhiyu">
            <h2 className="text-2xl sm:text-4xl md:text-5xl font-heading font-extrabold text-slate-900 mb-4" data-id="element-236" data-mp="3nhkmlmyfkj52">
              + <span className="text-court-deep" data-id="element-237" data-mp="3sgxj6zf3t4ku">6 Regalos</span> Estratégicos
            </h2>
            <p className="text-base sm:text-lg text-slate-600 font-medium mb-7 max-w-md mx-auto" data-id="element-238" data-mp="3eh5zci1wotyx">
              Incluidos sin costo extra · Valor real del pack
            </p>
            <div className="inline-flex items-center gap-2 bg-amber-400 text-slate-900 font-heading font-extrabold px-6 py-3 rounded-full text-sm sm:text-base shadow-lg shadow-amber-400/40 uppercase tracking-wide" data-id="element-239" data-mp="3jhk5tvnuzvuu">
              🎁 Gratis por el día de hoy
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5" data-id="element-240" data-mp="2yob0u23fyfio">
            <BonusCard num="1" icon={<Activity className="w-7 h-7" data-id="element-242" data-mp="2pp6513j9l0a7" />} title="NIVELÓMETRO 360" desc="Ubica a cualquier alumno en su nivel correcto en menos de 5 minutos. Nunca más adivines en qué tomo tiene que estar." data-id="element-241" data-mp="2ur578a39pr5k" />
            <BonusCard num="2" icon={<Zap className="w-7 h-7" data-id="element-244" data-mp="3df0gphrukisv" />} title="PREPARACIÓN FÍSICA DE 15 MINUTOS" desc="Rutinas específicas para el jugador de pádel. Sin gimnasio. Sin equipo. Solo tú, la cancha y el método." data-id="element-243" data-mp="3idtt16vee3rg" />
            <BonusCard num="3" icon={<Utensils className="w-7 h-7" data-id="element-246" data-mp="4zgqysqdxiik" />} title="NUTRICIÓN PARA EL JUGADOR DE PÁDEL" desc="Lo que comes decide el partido. Qué comer antes, durante y después. Sin dietas extremas. Sin suplementos caros." data-id="element-245" data-mp="33p7gfcx5nq3x" />
            <BonusCard num="4" icon={<CloudRain className="w-7 h-7" data-id="element-248" data-mp="ciztujj5a6i2" />} title="PLAN PARA CUANDO LLUEVE" desc="La lluvia cancela la cancha, no la clase. 10 actividades de alto valor para el día que no hay cancha." data-id="element-247" data-mp="7lpuoc5yegh1" />
            <BonusCard num="5" icon={<LifeBuoy className="w-7 h-7" data-id="element-250" data-mp="qj0rzr80yztu" />} title="KIT DE SUPERVIVENCIA DEL PROFE" desc="Grupos mixtos sin aviso, sin materiales, con 20 minutos o alumnos de mal humor. Protocolo de emergencia para cualquier situación." data-id="element-249" data-mp="migxkveu6abe" />
            <BonusCard num="6" icon={<Calendar className="w-7 h-7" data-id="element-252" data-mp="158gfmyc9ep5b" />} title="PACK DE ORGANIZACIÓN SEMANAL" desc="Plantillas para eliminar la ansiedad del domingo. Tus clases, pagos, materiales y pendientes en una sola hoja." data-id="element-251" data-mp="109c789x5svg1" />
          </div>
        </div>
      </section>
    </div>;
}
function StatBadge({
  icon,
  text
}: {
  icon: React.ReactNode;
  text: string;
}) {
  return <div className="flex flex-col items-center p-5 bg-slate-50 rounded-2xl border border-slate-200" data-id="element-253" data-mp="1qq0ye9pwophw">
      <div className="w-10 h-10 rounded-xl bg-blue-50 text-court-deep flex items-center justify-center mb-3" data-id="element-254" data-mp="1vpnagftzzzp4">
        {icon}
      </div>
      <p className="font-bold text-slate-800 text-sm sm:text-base leading-tight" data-id="element-255" data-mp="20gvndluje371">
        {text}
      </p>
    </div>;
}
function TomoCard({
  num,
  title,
  desc,
  level,
  accent
}: {
  num: string;
  title: string;
  desc: string;
  level: string;
  accent: string;
}) {
  return <div className="p-6 sm:p-7 rounded-2xl bg-white border border-slate-200 hover:border-slate-300 hover:shadow-lg transition-all" data-id="element-256" data-mp="2eflfso6evep2">
      <div className="flex items-center justify-between mb-4" data-id="element-257" data-mp="2je6kazsp4kjb">
        <span className="text-2xl font-heading font-extrabold text-slate-200" data-id="element-258" data-mp="k2n88cc3iw5f">
          {num.padStart(2, '0')}
        </span>
        <span className={`px-2.5 py-1 rounded-full text-[11px] font-bold uppercase tracking-wider border ${accent}`} data-id="element-259" data-mp="p1go2beuuz8r">
          {level}
        </span>
      </div>
      <h3 className="text-base sm:text-lg font-heading font-bold text-slate-900 mb-2.5 leading-snug" data-id="element-260" data-mp="cpo0bizu81du">
        {title}
      </h3>
      <p className="text-sm text-slate-600 leading-relaxed" data-id="element-261" data-mp="7rw3cakc5p2s">{desc}</p>
    </div>;
}
function BadgeItem({
  icon,
  text
}: {
  icon: string;
  text: string;
}) {
  return <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-full border border-slate-200 shadow-sm" data-id="element-262" data-mp="10f8oqherfqui">
      <span data-id="element-263" data-mp="vii55k3qyd4c">{icon}</span>
      <span className="font-semibold text-slate-700 text-xs sm:text-sm" data-id="element-264" data-mp="vf43yf6tk9yh">
        {text}
      </span>
    </div>;
}
function BonusCard({
  num,
  icon,
  title,
  desc
}: {
  num: string;
  icon: React.ReactNode;
  title: string;
  desc: string;
}) {
  return <div className="bg-amber-50/60 rounded-2xl p-6 sm:p-7 border border-amber-200 hover:border-amber-300 hover:shadow-lg transition-all" data-id="element-265" data-mp="3b9e4y09ilzur">
      <div className="flex items-start justify-between mb-5" data-id="element-266" data-mp="36bcprqf7mkok">
        <div className="w-12 h-12 rounded-xl bg-amber-400 text-slate-900 flex items-center justify-center" data-id="element-267" data-mp="1yb48v93ktzc7">
          {icon}
        </div>
        <span className="text-[11px] font-bold text-amber-800 bg-amber-200/70 border border-amber-300 px-2.5 py-1 rounded-full uppercase tracking-wider" data-id="element-268" data-mp="2291ygd19eng4">
          Bonus {num} · Gratis
        </span>
      </div>
      <h3 className="text-base sm:text-lg font-heading font-bold text-slate-900 mb-2.5 leading-snug" data-id="element-269" data-mp="1eltsrtzx5cdk">
        {title}
      </h3>
      <p className="text-sm text-slate-600 leading-relaxed" data-id="element-270" data-mp="1jcsb0z4gwkjg">{desc}</p>
    </div>;
}